import "./SimpleIconsPlate.scss";

const SimpleIconsPlate = ({children, vertical = false, shrink = true}) => {
    if (!children)
        return null;

    return <div className={'simple-icons-plate-wrapper'}>
        <div style={shrink ? undefined : {flexShrink: "0"}} className={`simple-icons-plate ${vertical ? 'simple-icons-vertical' : ''}`}>
            {children}
        </div>
    </div>;
}

export default SimpleIconsPlate;